var map = {
	"./brands/bitbucket.jpg": 29896,
	"./brands/dropbox.png": 93537,
	"./brands/figma.png": 67219,
	"./brands/firebase.png": 61148,
	"./brands/firebase.svg": 35688,
	"./brands/firebase.webp": 36004,
	"./brands/mailchimp.jpg": 15249,
	"./brands/matercard-2.png": 95995,
	"./brands/matercard.png": 45266,
	"./brands/mixpanel.png": 91267,
	"./brands/mixpanel.webp": 7717,
	"./brands/slack.png": 7199,
	"./brands/trello.png": 80301,
	"./browsers/brave.svg": 56846,
	"./browsers/chrome.png": 3338,
	"./browsers/edge.png": 86215,
	"./browsers/firefox.png": 94533,
	"./browsers/opera.png": 56119,
	"./browsers/safari.png": 20656,
	"./countries/alemanha.png": 85708,
	"./countries/argentina.png": 99494,
	"./countries/brasil-lg.png": 31634,
	"./countries/brazil.png": 14859,
	"./countries/china.png": 52072,
	"./countries/espanha-lg.png": 66163,
	"./countries/espanha.png": 45985,
	"./countries/estados-unidos-lg.png": 22777,
	"./countries/estados-unidos.png": 44271,
	"./countries/frança.png": 1268,
	"./countries/italia-lg.png": 50093,
	"./countries/italia.png": 87939,
	"./countries/russia.png": 19502,
	"./extensions/audio-box.jpg": 63573,
	"./extensions/audio-box.png": 42597,
	"./extensions/audio.png": 46269,
	"./extensions/excel.png": 19578,
	"./extensions/pdf-2.png": 31080,
	"./extensions/pdf.png": 2617,
	"./extensions/picture.png": 29141,
	"./extensions/play.png": 6973,
	"./extensions/txt.png": 89563,
	"./extensions/video.png": 27994,
	"./extensions/word.png": 17251,
	"./extras/arquivo-corrompido.png": 86736,
	"./extras/background.png": 19298,
	"./extras/backgrount.jpg": 11478,
	"./extras/chat.jpg": 60860,
	"./extras/chat.png": 14232,
	"./extras/corrupted-file.png": 10789,
	"./extras/css-3.png": 28261,
	"./extras/doc.png": 21082,
	"./extras/git.png": 10460,
	"./extras/golang.png": 29916,
	"./extras/html.png": 5333,
	"./extras/image-1.jpg": 91817,
	"./extras/image-2.jpg": 65086,
	"./extras/image-3.jpg": 96571,
	"./extras/image-4.jpg": 66568,
	"./extras/image-5.jpg": 93733,
	"./extras/image-6.jpg": 71130,
	"./extras/javascript.png": 52651,
	"./extras/pdf.png": 59990,
	"./extras/python.png": 39904,
	"./extras/unplugged.png": 33811,
	"./extras/xls.png": 26059,
	"./files/Atividade 2 - Faxina Financeira.xlsx": 16156,
	"./files/Visao Do Sistema Plus Car.docx": 38345,
	"./files/atlassian-git-cheatsheet.pdf": 66972,
	"./files/audio/dark-future-logo-196217.mp3": 61794,
	"./files/audio/inspiring-trailer-15-sec-203615.mp3": 98371,
	"./files/bebida-soda-vidro.mp4": 55303,
	"./files/boat-7092.mp4": 63706,
	"./files/chill-abstract-intention-12099.mp3": 91594,
	"./files/esfera-forma.mp4": 9589,
	"./files/git cheatsheet.docx": 91424,
	"./files/nature.mp4": 72620,
	"./files/pianchette-top.jpeg": 57878,
	"./files/regex_cheatsheet.pdf": 42484,
	"./files/rocks-82.jpeg": 91162,
	"./files/squirrel-82.jpeg": 10695,
	"./files/tags.txt": 53443,
	"./files/um-arquivo-simples.txt": 74014,
	"./files/um-olhar-profundo.txt": 25091,
	"./icons/avatar-square.png": 14612,
	"./icons/avatar.png": 33814,
	"./icons/bing.png": 85687,
	"./icons/check_box.svg": 84375,
	"./icons/check_box_outline_blank.svg": 52203,
	"./icons/exclamation.png": 50686,
	"./icons/facebook.png": 43853,
	"./icons/google.png": 63284,
	"./icons/instagram.png": 63505,
	"./icons/microsoft.png": 94249,
	"./icons/safari.png": 51333,
	"./icons/warning.png": 26181,
	"./logos/clover-favicon.svg": 95573,
	"./logos/clover-icon.png": 33792,
	"./logos/clover-icon.svg": 42208,
	"./logos/clover-logo-dark.png": 76053,
	"./logos/clover-logo-dark.svg": 8543,
	"./logos/clover-logo-light.png": 88813,
	"./logos/clover-logo-light.svg": 73917,
	"./logos/logo-1.png": 61644,
	"./logos/logo-2.png": 81703,
	"./logos/logo-3.png": 79742,
	"./svg/chat.svg": 78745,
	"./svg/undraw_feeling_blue.svg": 73652,
	"./svg/undraw_search.svg": 63239,
	"./users/14.png": 9420,
	"./users/beatriz.jpg": 59740,
	"./users/carolina.avif": 33844,
	"./users/emmilly.jpg": 34614,
	"./users/jennyfer.jpg": 49608,
	"./users/menina.png": 33405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;